module.exports={
    btn:{
        tips_reelect_btn:"Nieuw beeld",
        cancel_btn:"Annuleren",
        tips_continue_dispose:"Upscale ondersteunde afbeeldingen",
        tips_return:"Nieuw beeld",
        tips_upgrade:"Upgrade",
        tips_yes:"OK",
        delete:"Verwijderen",
        download:"Downloaden",
        upload_image:"Afbeelding uploaden",
        new_image:"Nieuw beeld",
        save_all:"Bewaar alles",
        cancel:"Annuleren",
        save:"Redden",
        view_comparison:"Vergelijking bekijken",
        hide_comparison:"Vergelijking verbergen",
        previous:"Vorig",
        next:"Volgende",
        continue_download:"Bewaar afbeeldingen met watermerken",
        present:"Toepassen op deze afbeelding",
        all_wait:"Toepassen op wachtende afbeeldingen",
        all:"Toepassen op alle afbeeldingen",
        history:"Geschiedenis",
        login:"Log in",
    },
    tips:{
        please_upgrade:"Uw huidige abonnement biedt geen ondersteuning voor het uploaden of opschalen van afbeeldingen in batches. Upgrade het om van meer voordelen te genieten.",
        errorlistinfo:"Er zijn XXX afbeeldingen geselecteerd. XXX afbeeldingen worden ondersteund, maar XXX afbeeldingen worden niet ondersteund. De volgende zijn niet-ondersteunde afbeeldingen:",
        max:"Overschrijd de maximale afbeeldingsgrootte van 10 MB!",
        max_size:"Overschrijd de maximale lengtelimiet van de afbeelding van 4096px!",
        continue_dispose:"Upscale ondersteunde afbeeldingen",
        please_multiple:"Selecteer de vergroting.",
        max_multiple:"* Je afbeelding wordt vergroot tot maximaal 4K (de langste zijde mag niet groter zijn dan 4096px).",
        title:"Naam",
        reasons:"Redenen",
        upload_type:"Niet ondersteund",
        used_up:"Het aantal opgeslagen HD-beelden zonder watermerk is op. Upgrade uw account. Of u kunt HD-afbeeldingen opslaan met watermerken.",
        edit_multiple:"Er zijn meerdere afbeeldingen geüpload. Selecteer afbeeldingen waarvan u de vergroting wilt wijzigen. Na selectie worden deze beelden weer opgeschaald naar de nieuwe vergroting.",
        download_confirm:"Sommige afbeeldingen worden nog verwerkt. Weet u zeker dat u alle opgeschaalde afbeeldingen wilt opslaan? Wanneer u dezelfde afbeelding herhaaldelijk opslaat, wordt uw aantal opgeslagen afbeeldingen niet opnieuw afgetrokken.",
        waiting_save:"Sommige afbeeldingen worden nog verwerkt. Gelieve later op te slaan.",
        
    },
    header:{
        title:"Aiseesoft Image Upscaler online",
        hd:" HD-afbeelding(en)",
        watermarks:"zonder watermerken kan momenteel worden gedownload.",
        view_details:"Details bekijken",
        loading:"Bezig met laden…",
    },
    content:{
        failed:"Mislukt",
        completed:"Voltooid",
        processing:"Verwerken",
        img_processing:"Verwerken…",
        img_failed:"Kan niet verwerken",
        uploading:"Uploaden",
        img_uploading:"Uploaden...",
        wait_upoading:"Wachten met uploaden...",
        waiting:"Aan het wachten",
        img_waiting:"Aan het wachten…",
        empty:"Leeg",
        magnification:"Vergroting:",
        drop:"Of plaats hier uw afbeeldingsbestand om op te schalen en te verbeteren!",
        original:"origineel:",
        output:"Uitgang:",
        img_rendering1:"Uw afbeelding is opgeschaald.",
        img_rendering2:"We werken aan het weergeven van de afbeelding van hoge kwaliteit voor een voorbeeld. Even geduld a.u.b....",
        no_watermark:"Na het opslaan heeft de afbeelding geen watermerk.",
    },
    banner_msg:"Kies een abonnement voor Image Upscaler",
    monthly:"MAANDELIJKS",
    lifetime:"LEVENSLANG",
    choose_plan:"Kies je abonnement op basis van het aantal afbeeldingen",
    return_home:"Gefeliciteerd! Je hebt succesvol geüpgraded. Ga terug naar de startpagina en gebruik dit product.",
    congratulations:"Gefeliciteerd! Je hebt succesvol geüpgraded. De voordelen zijn gekoppeld aan het e-mailadres dat je hebt achtergelaten tijdens het upgraden. Gebruik hiervoor het geregistreerde of gekoppelde account aan het e-mailadres",
    login_benefits:"login voor het gebruik van voordelen",
    no_registered:". Als u zich niet heeft geregistreerd of geen account hebt gekoppeld aan het e-mailadres, alstublieft",
    register_account:"gebruik het e-mailadres om een account te registreren",
    other_accounts:" of koppel andere accounts aan dit e-mailadres om gebruik te maken van voordelen.",
    btn_close:"Dichtbij",
    free:"Vrij",
    btn_get_started:"Begin",
    // access_to:"Toegang tot",
    upscale_images:"Luxe afbeeldingen",
    up_to:"Tot",
    per_image:" per afbeelding",
    resolution_of:"Tot resolutie van",
    default_level:"Upscale afbeeldingen op standaardniveau",
    image_downloads:"2 HD-beelddownloads zonder watermerk",
    unlimited_image:"Onbeperkt downloaden van afbeeldingen met watermerk",
    SHA256_encryption:"SHA256-coderingstechniek",
    mon:"Maandelijks",
    images:"afbeeldingen",
    high_resolution:" met hoge resolutie kwaliteit",
    tax_incl:"Incl. btw.",
    image:"afbeelding",
    secure_checkout:"Veilig uitchecken",
    everything:"Alles in Gratis, en",
    upscaling_levels:"Alle opschalingsniveaus kunnen worden geselecteerd",
    unlimited_image_without:"Onbeperkt downloaden van afbeeldingen zonder watermerk",
    viewable_editing:"Zichtbare bewerkingsgeschiedenis is geldig voor",
    days:" dagen",
    high_level:"Hoog niveau",
    priority_processing:" prioritaire verwerking",
    left:"Levenslang",
    resolution:" oplossing",


    "history_will":"Vervalt daarna",
    "history.days":"Dag(en)",
    "history.hours":"uur",
    "expired":"Verlopen",
    "access_to":"Met de gratis proefperiode kan dat alleen",
    "pricing.upload_images":"Upload afbeeldingen",
    "pricing.under":"onder",
    "pricing.images":"afbeeldingen",
    "pricing.without_watermark":"zonder watermerk",
    "pricing.process_images":"Verwerk beelden tot",
    "pricing.pixels":"pixels",
    "pricing.enjoy_limited":"Geniet van beperkte luxe kwaliteiten",
    "pricing.download":"Downloaden",
    "pricing.HD_images":"HD-beelden zonder watermerk",
    "pricing.and_you":"En je kunt er last van hebben",
    "pricing.slow_upscaling":"langzaam opschalen",
    "pricing.lower_priority":"lagere prioriteit",
    "pricing.without":"zonder watermerk",
    "pricing.tax":"Belasting is inbegrepen in de verkoopprijs en wordt automatisch berekend op basis van uw land en regio. In de winkelwagen ziet u het gedetailleerde btw-bedrag. Uw uiteindelijke betalingsbedrag is hetzelfde als de weergegeven prijs.",
    "pricing.you_can":"Met een abonnement kan dat",
    "pricing.up_to":"Upload afbeeldingen tot",
    "pricing.upscale_images":"Luxe afbeeldingen met",
    "pricing.no_watermark":"geen watermerk",
    "pricing.enhance":"Uitbreiden",
    "pricing.or_more":"afbeeldingen of meer",
    "pricing.in_batch":"in partij",
    "pricing.enlarge_images":"Vergroot afbeeldingen in",
    "pricing.and":"En",
    "pricing.times_with":"tijden zonder limiet",
    "pricing.enjoy":"Genieten",
    "pricing.of_history":"van de opslagtijd van de geschiedenis",
    "pricing.experience":"Ervaring",
    "pricing.fast_upscaling":"snelle opschaling",
    "pricing.higher_priority":"hogere prioriteit",
    "pricing.early_access":"Vroegtijdige toegang tot nieuwe functies",
    "pricing.cancel_anytime":"Annuleer op elk moment",
    "pricing.lifetime_license":"Met levenslange licentie kan dat",
    "pricing.and_there":"En dat zal er zijn",
    "pricing.no_expiration":"geen vervaldatum",
    "pricing.unless":"tenzij je alle upscales opraakt",

    "buynow.pop.credit":"credit",
    "buynow.pop.credits":"tegoeden",

    "isUnderequityTip_msg1":"Je hebt {%} afbeeldingen geselecteerd voor batchverwerking en er zijn niet genoeg resterende voordelen. Je hebt nog steeds {%} credits nodig (momenteel zijn er nog {%} credits over). Als je de afbeeldingen moet verwerken, koop dan voordelen om door te gaan het verwerken van de beelden.",
    "isUnderequityTip_msg2":"Je hebt {%} afbeeldingen geselecteerd voor batchverwerking en er zijn niet genoeg resterende voordelen. Je hebt nog steeds {%} credits nodig (momenteel zijn er nog {%} afbeeldingen van voordelen over). Als je de voordelen wilt verwerken, koop dan voordelen om door te gaan met het verwerken van de afbeeldingen.",
    "isUnderequityTip_msg3":"Je hebt {%} afbeeldingen geselecteerd voor batchverwerking en er zijn niet genoeg resterende voordelen. Je hebt nog steeds {%} credits nodig (momenteel zijn er nog {%} credits, {%} afbeeldingen aan voordelen over). Als dat nodig is proces, koop dan voordelen om door te gaan met het verwerken van de afbeeldingen.",
    "btn_buy_now":"Koop nu",
    "isEquityDepletionTip_msg":"Uw huidige voordelen zijn opgebruikt. Koop de voordelen voor batchverwerking.",

    "pricing.h1":"Aiseesoft AI Photo Editor - Plannen en Prijzen",
    "pricing.banner_content":"Krijg AI Photo Editor-credits om achtergronden van afbeeldingen te verwijderen, afbeeldingen te upscalen en objecten uit afbeeldingen te verwijderen online of vanaf het bureaublad.",
    "pricing.best_seller":"Best Seller",
    "pricing.monthly":"Maandelijks Abonnement",
    "pricing.credits":"credits",
    "pricing.lifetime":"Levenslang",
    "pricing.note":"Opmerking",
    "pricing.buy_now":"Koop nu",
    "pricing.note_content":"Gekochte credits zijn gekoppeld aan het e-mailadres dat u in het winkelwagentje hebt ingevoerd. Om deze credits te gebruiken, registreert u zich of logt u in met hetzelfde e-mailadres.",

    "header.buy_more":"Koop meer",
    "header.available_credits":"Beschikbare credits",
    "header.credits":"credit(s)"
}